import { Injectable } from '@angular/core';
import { Account, AccountsService, ListResponse } from '@vendasta/accounts/legacy';
import { combineLatest, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AppConfig, AppConfigService } from './app-config.service';
import { CustomerVoiceRouterService } from './cv-router.service';

@Injectable()
export class ProductService {
  public accountGroupHasCustomerVoice$: Observable<boolean>;

  constructor(
    private accountsService: AccountsService,
    private appConfigService: AppConfigService,
    private customerVoiceRouterService: CustomerVoiceRouterService,
  ) {
    this.accountGroupHasCustomerVoice$ = combineLatest([
      this.appConfigService.appConfig,
      this.customerVoiceRouterService.accountGroupId,
    ]).pipe(
      switchMap(([config, accountGroupId]: [AppConfig, string]) => {
        const partnerId = config.partnerId;
        const customerVoiceAppId = config.vendorCenterAppId;
        return this.checkCustomerVoice(accountGroupId, partnerId, customerVoiceAppId);
      }),
    );
  }

  checkCustomerVoice(accountGroupId: string, partnerId: string, customerVoiceAppId: string): Observable<boolean> {
    return this.accountsService.list(accountGroupId, partnerId).pipe(
      map((listResponse: ListResponse) => listResponse.accounts),
      map((accounts: Account[]) => {
        return accounts.some((account: Account) => {
          const appId = account.appId || account.productId;
          const isActive = !account.trial || (account.trial && new Date(account.deactivation) > new Date());
          return appId === customerVoiceAppId && isActive;
        });
      }),
      catchError((err: Error) => {
        console.error(err.message);
        return of(false);
      }),
    );
  }
}
